import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import feedsActions from '../../redux/feeds/actions';
import InventoryNav from '../../components/InventoryNav';
import FeedList from '../../components/FeedList';
import SidebarContainer from '../SidebarContainer';
import './Feeds.scss';

class Feeds extends Component {
  componentDidMount() {
    this.props.actions.resetFeed();
    this.props.actions.feedsRequest();
  }

  onEdit = async (feedId) => {
    this.props.actions.feedRequest(feedId);
  };

  render() {
    const { actions, feeds } = this.props;
    return (
      <SidebarContainer title="Inventory Feed Manager" openSubMenu="Inventory">
        <div className="feeds-table">
          <InventoryNav />
          <FeedList
            list={feeds.feeds}
            error={feeds.error}
            success={feeds.success}
            fetching={feeds.fetching}
            onDelete={actions.deleteFeedRequest}
            onEdit={this.onEdit}
          />
        </div>
      </SidebarContainer>
    );
  }
}

Feeds.propTypes = {
  feeds: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ feeds }) => ({ feeds });

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      ...feedsActions,
    },
    dispatch,
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Feeds);
